<div class="card" [@focusShadow]="(isCollapsed$ | async)?'blur':'focus'">
  <ds-truncatable [id]="dso.id">
    <div class="position-absolute ms-1">
      <ng-content></ng-content>
    </div>
    @if (linkType !== linkTypes.None) {
      <a
        [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
        [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="[itemPageRoute]"
        class="card-img-top full-width" [attr.title]="'search.results.view-result' | translate" tabindex="-1">
        <div>
          <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="false">
          </ds-thumbnail>
        </div>
      </a>
    }
    @if (linkType === linkTypes.None) {
      <span class="card-img-top full-width">
        <div>
          <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="false">
          </ds-thumbnail>
        </div>
      </span>
    }
    <div class="card-body">
      @if (showLabel) {
        <ds-badges [object]="dso" [context]="context"></ds-badges>
      }
      <ds-truncatable-part [id]="dso.id" [minLines]="3" type="h4">
        <h4 class="card-title" [innerHTML]="dsoTitle"></h4>
      </ds-truncatable-part>
      @if (dso.hasMetadata('person.email')) {
        <p class="item-email card-text text-muted">
          <ds-truncatable-part [id]="dso.id" [minLines]="1">
            <span [innerHTML]="firstMetadataValue('person.email')"></span>
          </ds-truncatable-part>
        </p>
      }
      @if (dso.hasMetadata('person.jobTitle')) {
        <p class="item-jobtitle card-text">
          <ds-truncatable-part [id]="dso.id" [minLines]="3">
            <span [innerHTML]="firstMetadataValue('person.jobTitle')"></span>
          </ds-truncatable-part>
        </p>
      }
      @if (linkType !== linkTypes.None) {
        <div class="text-center">
          <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
            [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="[itemPageRoute]"
          class="lead btn btn-primary viewButton" role="link" tabindex="0">{{ 'search.results.view-result' | translate}}</a>
        </div>
      }
    </div>
  </ds-truncatable>
  <ng-content></ng-content>
</div>
